import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { AS } from "../AirfoilStyles/index.js";
import { Icons24 } from "../Icons24Sprite/index.js";
import { IconWrapper } from "../IconWrapper/index.js";
import { cn as clsx } from "../../helpers/react.js";
import cornerSvg from "../../assets/svg/corner.22419ac0.svg";
import '../../assets/index.css';const hover = "_hover_1kp5i_2";
const enableDragIcon = "_enableDragIcon_1kp5i_8";
const videoRoot = "_videoRoot_1kp5i_13";
const withShadow = "_withShadow_1kp5i_23";
const newToolbar = "_newToolbar_1kp5i_38";
const alwaysVisible = "_alwaysVisible_1kp5i_48";
const progress = "_progress_1kp5i_52";
const videoToolbarItem = "_videoToolbarItem_1kp5i_59";
const textItem = "_textItem_1kp5i_67";
const flex1 = "_flex1_1kp5i_79";
const videoHeader = "_videoHeader_1kp5i_83";
const textContainer = "_textContainer_1kp5i_96";
const text = "_text_1kp5i_67";
const airline = "_airline_1kp5i_116";
const icon = "_icon_1kp5i_122";
const timeBadge = "_timeBadge_1kp5i_130";
const corner = "_corner_1kp5i_134";
const s = {
  hover,
  enableDragIcon,
  videoRoot,
  withShadow,
  newToolbar,
  alwaysVisible,
  progress,
  videoToolbarItem,
  textItem,
  flex1,
  videoHeader,
  textContainer,
  text,
  airline,
  icon,
  timeBadge,
  corner
};
const Root = forwardRef(({ className, enableShadow = true, children, ...rest }, ref) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...rest,
      className: clsx(
        s.videoRoot,
        {
          [s.withShadow]: enableShadow
        },
        className
      ),
      ref,
      children
    }
  );
});
const Toolbar = forwardRef(
  ({ className, leftSection, rightSection, progressSection, alwaysVisible: alwaysVisible2, ...rest }, ref) => {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ...rest,
        className: clsx(
          s.newToolbar,
          {
            [s.alwaysVisible]: alwaysVisible2
          },
          className
        ),
        ref,
        children: [
          leftSection,
          /* @__PURE__ */ jsx("div", { className: s.flex1 }),
          rightSection,
          /* @__PURE__ */ jsx(VideoToolbarItemSlot, { children: /* @__PURE__ */ jsx("div", { className: s.progress, children: progressSection }) })
        ]
      }
    );
  }
);
const VideoToolbarItemSlot = forwardRef(({ alwaysVisible: alwaysVisible2 = false, className, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    Slot,
    {
      ...props,
      className: clsx(
        s.videoToolbarItem,
        {
          [s.alwaysVisible]: alwaysVisible2
        },
        className
      ),
      ref
    }
  );
});
const Text = forwardRef(({ className, children, ...rest }, ref) => {
  return /* @__PURE__ */ jsx("span", { ...rest, className: clsx(s.textItem, className), ref, children });
});
const Corner = forwardRef(({ className, children, alwaysVisible: alwaysVisible2, ...rest }, ref) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...rest,
      className: clsx(
        s.corner,
        {
          [s.alwaysVisible]: alwaysVisible2
        },
        className
      ),
      ref,
      children: /* @__PURE__ */ jsx("img", { src: cornerSvg })
    }
  );
});
const VideoHeader = forwardRef(
  ({ className, icon: icon2, standLabel, flightNumber, timeBadgeElement, progressMessage, showDraggableIcon, ...rest }, ref) => {
    return /* @__PURE__ */ jsxs("section", { ...rest, className: clsx(s.videoHeader, className), ref, children: [
      showDraggableIcon && /* @__PURE__ */ jsx(IconWrapper, { size: "md", className: s.icon, children: /* @__PURE__ */ jsx(Icons24, { name: "Draggable" }) }),
      /* @__PURE__ */ jsx(IconWrapper, { size: "md", className: s.airline, children: icon2 }),
      /* @__PURE__ */ jsx("span", { className: s.text, children: standLabel }),
      flightNumber && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: s.text, children: "•" }),
        /* @__PURE__ */ jsx("span", { className: s.text, children: flightNumber })
      ] }),
      progressMessage && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: s.text, children: "•" }),
        /* @__PURE__ */ jsx("span", { className: s.text, children: progressMessage })
      ] }),
      /* @__PURE__ */ jsx("div", { className: s.flex1 }),
      /* @__PURE__ */ jsx(AS, { theme: "light", children: timeBadgeElement })
    ] });
  }
);
Root.displayName = "Video";
const Video = Object.assign(Root, {
  Toolbar,
  ItemSlot: VideoToolbarItemSlot,
  Text,
  Corner,
  Header: VideoHeader,
  /**
   * Sets all necessary styles for the hover effect.
   * Must be applied to the container element.
   */
  hoverClassName: ({ enableDragIcon: enableDragIcon2 } = {}) => clsx(s.hover, {
    [s.enableDragIcon]: enableDragIcon2
  })
});
export {
  Video
};
